import type { Hex } from 'viem';
import type { PartyCardPayload, PartySeatView } from '../types/server';

export interface PartyInviteContext {
  self: Hex | null | undefined;
  hosting: boolean;
  held: PartyCardPayload | null;
  claimAccepted: boolean;
}

// Canonical seats are [p0, p2, p1, p3], so side 1 is indices 2 and 3. A fully-CPU side has no
// revealer and rides the CPU host path, the only route that needs no per-seat consent.
export function partyRidesCpuHost(seats: readonly PartySeatView[]): boolean {
  return seats[2]?.kind === 'cpu' && seats[3]?.kind === 'cpu';
}

// A lobby advert carries no seat, so the invite takes the lowest open one. Returns null when the
// card shouldn't replace what's on screen.
export function resolvePartyInvite(card: PartyCardPayload, ctx: PartyInviteContext): PartyCardPayload | null {
  if (card.host.toLowerCase() === ctx.self?.toLowerCase()) return null;
  if (card.yourSeatIndex === null && ctx.hosting) return null;

  const { held } = ctx;
  if (held?.partyId === card.partyId) {
    const heldNamed = held.yourSeatIndex !== null && held.seats[held.yourSeatIndex]?.kind === 'named';
    if (heldNamed || ctx.claimAccepted) return null;
  }

  const seat = card.yourSeatIndex ?? card.seats.findIndex((s) => s.kind === 'open' && !s.filled);
  return seat < 0 ? null : { ...card, yourSeatIndex: seat };
}
